import {BaseModel} from "../base";

class AdminObjectMappingModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    $update(objectMapping) {
        return this.$put('self', {}, objectMapping);
    }

    $createObjectMapping(objectMapping, implementation) {
        const params = {
            internal_type: objectMapping.internal_type,
            internal_id: objectMapping.internal_id
        };

        return implementation.$post('object_mappings', params, objectMapping);
    }
}

export {
    AdminObjectMappingModel
}